import { render, staticRenderFns } from "./RevenueTypeAdd.vue?vue&type=template&id=09978d68&scoped=true&"
import script from "./RevenueTypeAdd.vue?vue&type=script&lang=js&"
export * from "./RevenueTypeAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09978d68",
  null
  
)

export default component.exports